

























import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import type { DsrResource } from '@getaccept/lib-shared/src/library/types/dsr-resource';
import { RainbowColor } from '@getaccept/lib-ui';
import TypeCell from '@getaccept/lib-shared/src/library/components/TypeCell.vue';
import DateCell from '@getaccept/lib-shared/src/library/components/DateCell.vue';
import NameCell from '@getaccept/lib-shared/src/library/components/NameCell.vue';
import { LibraryHelper } from '@getaccept/lib-shared/src/library/helpers/library.helper';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  name: 'TemplateRow',
  components: {
    NameCell,
    TypeCell,
    DateCell,
  },
  props: {
    template: {
      type: Object as PropType<DsrResource>,
      required: true,
    },
  },
  setup(props) {
    const usedCountText = computed(() =>
      t('dsr-content-lib__n_times', { num: props.template.statistics.useCount })
    );

    return {
      RainbowColor,
      usedCountText,
      convertToISODate: LibraryHelper.convertToISODate,
    };
  },
});
